// import React,{useState,useEffect} from "react";
// import axios from "axios";

// function Register(){

// const [roles,setRoles]=useState([]);

// const [formData,setFormData]=useState({
// first_name:"",
// last_name:"",
// email:"",
// phone_number:"",
// role:"PM"
// });

// // useEffect(()=>{
// // fetchRoles();
// // },[]);


// // const fetchRoles=async()=>{
// // try{
// // const res=await axios.get(
// // "http://127.0.0.1:8000/roles/"
// // );
// // setRoles(res.data);
// // }
// // catch(error){
// // console.log(error);
// // }
// // };


// const handleChange=(e)=>{
// setFormData({
// ...formData,
// [e.target.name]:e.target.value
// });
// };


// const handleSubmit = async (e) => {
//   e.preventDefault();

//   try {
//     const res = await axios.post(
//       "http://127.0.0.1:8000/api/register/",
//       formData,
//       {
//         headers: {
//           // Fix for your "Accept" header error
//           "Accept": "application/json",
//           "Content-Type": "application/json",
//         }
//       }
//     );

//     // Backend returns 'temp_pass' based on your serializer logic
//     const tempPass = res.data.temp_pass || res.data.temp_password;

//     alert(
//       `Registration Successful!\n\n` +
//       `Your account is pending admin approval.\n` +
//       `Temporary Password: ${tempPass}`
//     );

//   } catch (err) {
//     console.error("Error details:", err.response?.data);
    
//     // Improved error reporting
//     const errorMsg = err.response?.data?.email?.[0] || 
//                      err.response?.data?.phone_number?.[0] || 
//                      "Registration failed";
    
//     alert(errorMsg);
//   }
// };


// return(
// <div className="form-box">
// <h2>Create Account</h2>

// <form onSubmit={handleSubmit}>

// <input
// name="first_name"
// placeholder="First Name"
// onChange={handleChange}
// />

// <input
// name="last_name"
// placeholder="Last Name"
// onChange={handleChange}
// />

// <input
// type="email"
// name="email"
// placeholder="Email"
// onChange={handleChange}
// />

// <input
// name="phone_number"
// placeholder="Phone Number"
// onChange={handleChange}
// />

// {/* <select
// name="role"
// onChange={handleChange}
// >
// <option value="">
// Select Role
// </option>

// {
// roles.map(role=>(
// <option
// key={role.id}
// value={role.name}
// >
// {role.name}
// </option>
// ))
// }

// </select> */}

// <button className="submit-btn">
// Register
// </button>

// </form>

// </div>
// )

// }

// export default Register;



// import React, { useState } from "react";
// import axios from "axios";

// function Register() {
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     phone_number: "",
//     role: "PM"
//   });

//   const [errors, setErrors] = useState({});
  
//   // 1. Intercept keystrokes to physically block invalid keys
//   const handleKeyDown = (e) => {const { name } = e.target; 
//   const key = e.key;
//   const Base_URL = process.env.REACT_APP_API_BASE_URL
//     // Allow control keys (Backspace, Delete, Arrow keys, Tab, Enter)
//     const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"].includes(key);

//     if (isControlKey) return;

//     // Validation rules per keypress
//     if (name === "first_name" || name === "last_name") {
//       // Allow ONLY letters (A-Z, a-z). Block spaces, numbers, and symbols.
//       if (!/^[a-zA-Z]$/.test(key)) {
//         e.preventDefault(); 
//       }
//     }

//     if (name === "phone_number") {
//       // Allow ONLY numbers
//       if (!/^\d$/.test(key)) {
//         e.preventDefault();
//         return;
//       }

//       // If it is the first character, it MUST be 6, 7, 8, or 9
//       if (e.target.value.length === 0 && !/^[6-9]$/.test(key)) {
//         e.preventDefault();
//       }

//       // Max length enforcement (don't allow more than 10 digits)
//       if (e.target.value.length >= 10) {
//         e.preventDefault();
//       }
//     }
//   };

//   // 2. Handle normal state changes and validations (Length & Email syntax)
//   const validateField = (name, value) => {
//     let errorMsg = "";

//     if (!value.trim()) {
//       errorMsg = `${name.replace("_", " ")} is required.`;
//     } else {
//       switch (name) {
//         case "first_name":
//         case "last_name":
//           if (value.length < 2 || value.length > 30) {
//             errorMsg = "Must be between 2 and 30 characters.";
//           }
//           break;
//         case "email":
//           const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//           if (!emailRegex.test(value)) {
//             errorMsg = "Please enter a valid email address.";
//           }
//           break;
//         case "phone_number":
//           if (value.length !== 10) {
//             errorMsg = "Must be exactly 10 digits.";
//           }
//           break;
//         default:
//           break;
//       }
//     }

//     setErrors((prev) => ({ ...prev, [name]: errorMsg }));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     validateField(name, value);
//   };

//   const isFormValid = () => {
//     const newErrors = {};
//     Object.keys(formData).forEach((key) => {
//       if (key === "role") return;
//       if (!formData[key].trim()) {
//         newErrors[key] = `${key.replace("_", " ")} is required.`;
//       }
//     });

//     const combinedErrors = { ...errors, ...newErrors };
//     setErrors(combinedErrors);
//     return !Object.values(combinedErrors).some((error) => error !== "");
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!isFormValid()) return;

//     try {
//       const res = await axios.post(`${Base_URL}/api/register/`, formData, {
//         headers: { "Accept": "application/json", "Content-Type": "application/json" }
//       });
//       alert(`Registration Successful! Temp Password: ${res.data.temp_pass || res.data.temp_password}`);
//     } catch (err) {
//       alert("Registration failed");
//     }
//   };

//   return (
//     <div className="form-box">
//       <h2>Create Account</h2>

//       <form onSubmit={handleSubmit} noValidate>
        
//         <div className={`input-group ${errors.first_name ? "has-error" : ""}`}>
//           <input
//             name="first_name"
//             placeholder="First Name"
//             value={formData.first_name}
//             onChange={handleChange}
//             onKeyDown={handleKeyDown} 
//           />
//           {errors.first_name && <span className="error-text">{errors.first_name}</span>}
//         </div>

//         <div className={`input-group ${errors.last_name ? "has-error" : ""}`}>
//           <input
//             name="last_name"
//             placeholder="Last Name"
//             value={formData.last_name}
//             onChange={handleChange}
//             onKeyDown={handleKeyDown} 
//           />
//           {errors.last_name && <span className="error-text">{errors.last_name}</span>}
//         </div>

//         <div className={`input-group ${errors.email ? "has-error" : ""}`}>
//           <input
//             type="email"
//             name="email"
//             placeholder="Email"
//             value={formData.email}
//             onChange={handleChange}
//             // Note: We don't block keys on email since it needs special characters (@, .)
//           />
//           {errors.email && <span className="error-text">{errors.email}</span>}
//         </div>

//         <div className={`input-group ${errors.phone_number ? "has-error" : ""}`}>
//           <input
//             type="text"
//             name="phone_number"
//             placeholder="Phone Number"
//             value={formData.phone_number}
//             onChange={handleChange}
//             onKeyDown={handleKeyDown} 
//           />
//           {errors.phone_number && <span className="error-text">{errors.phone_number}</span>}
//         </div>

//         <button className="submit-btn">Register</button>
//       </form>
//     </div>
//   );
// }

// export default Register;



import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

// Fallback host constant if the environment variable is not defined
const DEFAULT_BASE_URL = "http://127.0.0.1:8000";
const Base_URL = process.env.REACT_APP_API_BASE_URL || DEFAULT_BASE_URL;

const initialFormState = {
  first_name: "",
  last_name: "",
  email: "",
  phone_number: "",
  role: "PM"
};

function Register({ switchToLogin }) {
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});

  // 1. Intercept keystrokes to physically block invalid keys
  const handleKeyDown = (e) => {
    const { name } = e.target; 
    const key = e.key;

    // Allow control keys (Backspace, Delete, Arrow keys, Tab, Enter)
    const isControlKey = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter"].includes(key);

    if (isControlKey) return;

    // Validation rules per keypress
    if (name === "first_name" || name === "last_name") {
      // Allow ONLY letters (A-Z, a-z). Block spaces, numbers, and symbols.
      if (!/^[a-zA-Z]$/.test(key)) {
        e.preventDefault(); 
      }
    }

    if (name === "phone_number") {
      // Allow ONLY numbers
      if (!/^\d$/.test(key)) {
        e.preventDefault();
        return;
      }

      // If it is the first character, it MUST be 6, 7, 8, or 9
      if (e.target.value.length === 0 && !/^[6-9]$/.test(key)) {
        e.preventDefault();
      }

      // Max length enforcement (don't allow more than 10 digits)
      if (e.target.value.length >= 10) {
        e.preventDefault();
      }
    }
  };

  // 2. Handle normal state changes and validations (Length & Email syntax)
  const validateField = (name, value) => {
    let errorMsg = "";

    if (!value.trim()) {
      errorMsg = `${name.replace("_", " ")} is required.`;
    } else {
      switch (name) {
        case "first_name":
        case "last_name":
          if (value.length < 2 || value.length > 30) {
            errorMsg = "Must be between 2 and 30 characters.";
          }
          break;
        case "email":
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(value)) {
            errorMsg = "Please enter a valid email address.";
          }
          break;
        case "phone_number":
          if (value.length !== 10) {
            errorMsg = "Must be exactly 10 digits.";
          }
          break;
        default:
          break;
      }
    }

    setErrors((prev) => ({ ...prev, [name]: errorMsg }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };

  const isFormValid = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (key === "role") return;
      if (!formData[key].trim()) {
        newErrors[key] = `${key.replace("_", " ")} is required.`;
      }
    });

    const combinedErrors = { ...errors, ...newErrors };
    setErrors(combinedErrors);
    return !Object.values(combinedErrors).some((error) => error !== "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) return;

    try {
      const res = await axios.post(`${Base_URL}/api/register/`, formData, {
        headers: { "Accept": "application/json", "Content-Type": "application/json" }
      });
      
      toast.success(
  "Registration Successful! Wait for admin approval.",
);
      
      // 1. Clear Form Data Fields
      setFormData(initialFormState);
      
      // 2. Clear out existing validation error messaging blocks
      setErrors({});
      
      // 3. Shift panel slider view back to the active Login layout index
      if (switchToLogin) {
        switchToLogin();
      }
      
    } catch (err) {
  console.error(err);

  let errorMessage = "Registration failed.";

  if (err.response?.data) {
    const data = err.response.data;

    if (data.error) {
      errorMessage = data.error;
    } else {
      const firstField = Object.keys(data)[0];

      if (firstField && Array.isArray(data[firstField])) {
        errorMessage = `${firstField.replace("_", " ")}: ${data[firstField][0]}`;
      }
    }
  }

  toast.error(errorMessage);
}
  };

  return (
    <div className="form-box">
      <h2>Create Account</h2>

      <form onSubmit={handleSubmit} noValidate>
        
        <div className={`input-group ${errors.first_name ? "has-error" : ""}`}>
          <input
            name="first_name"
            placeholder="First Name"
            value={formData.first_name}
            onChange={handleChange}
            onKeyDown={handleKeyDown} 
          />
          {errors.first_name && <span className="error-text">{errors.first_name}</span>}
        </div>

        <div className={`input-group ${errors.last_name ? "has-error" : ""}`}>
          <input
            name="last_name"
            placeholder="Last Name"
            value={formData.last_name}
            onChange={handleChange}
            onKeyDown={handleKeyDown} 
          />
          {errors.last_name && <span className="error-text">{errors.last_name}</span>}
        </div>

        <div className={`input-group ${errors.email ? "has-error" : ""}`}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <span className="error-text">{errors.email}</span>}
        </div>

        <div className={`input-group ${errors.phone_number ? "has-error" : ""}`}>
          <input
            type="text"
            name="phone_number"
            placeholder="Phone Number"
            value={formData.phone_number}
            onChange={handleChange}
            onKeyDown={handleKeyDown} 
          />
          {errors.phone_number && <span className="error-text">{errors.phone_number}</span>}
        </div>

        <button className="submit-btn" type="submit">Register</button>
      </form>
    </div>
  );
}

export default Register;